<template>
  <FormContainer :withoutDivider="moduleEnCours?.typeModule === 'Interne'">
    <template #title>Informations Module</template>
    <template #content>
      <div class="form__bloc">
        <WrapperCheckbox
          id="field_19"
          v-if="moduleEnCours?.typeModule === 'Interne'"
          :model-value="moduleEnCours?.attestationMoyenRealisation"
          @update:model-value="(value: any) => updateModule('attestationMoyenRealisation', activeModuleIndex!, value)"
          label="L’employeur atteste que le service de formation interne dispose des moyens nécessaires à la réalisation de la formation du salarié"
          :alertLabel="metaModuleEnCours?.attestationMoyenRealisation?.$messageErreurDirty!"
          :readonly
          class="col-36"
        />
      </div>
      <div class="form__bloc">
        <WrapperDropdown
          id="field_30"
          :model-value="moduleEnCours?.modalitePedagogique"
          @update:model-value="(value: any) => updateModule('modalitePedagogique', activeModuleIndex!, value)"
          label="Modalité pédagogique"
          class="col-24 col-md-24 col-sm-36"
          :items="lov.ModalitePedagogique"
          :required="metaModuleEnCours?.modalitePedagogique?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.modalitePedagogique?.$messageErreurDirty!"
          key-id="code"
          key-label="intitule"
          :readonly
        />

        <WrapperInputNumber
          id="field_17"
          :model-value="moduleEnCours?.dureeFoad"
          @update:model-value="(value: any) => updateModule('dureeFoad', activeModuleIndex!, value)"
          label="Durée de la FOAD"
          class="col-8 col-md-10 col-sm-36"
          placeholder="Heures"
          :required="metaModuleEnCours?.dureeFoad?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.dureeFoad?.$messageErreurDirty!"
          :readonly
          :disabled="dureeFoadDisabled"
        />
      </div>

      <div class="form__bloc">
        <WrapperInputNumber
          id="field_20"
          :model-value="moduleEnCours?.duree"
          @update:model-value="(value: any) => updateModule('duree', activeModuleIndex!, value)"
          label="Durée totale de la formation"
          class="col-12 col-md-12 col-sm-36"
          placeholder="Heures"
          :required="metaModuleEnCours?.duree?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.duree?.$messageErreurDirty!"
          :readonly
          deletable
          :decimal="2"
        />

        <div class="col-12 col-md-12 col-sm-36"></div>
      </div>
      <div class="form__bloc">
        <WrapperInputDate
          id="field_23"
          :model-value="moduleEnCours?.dateDebut"
          @update:model-value="(value: any) => updateModule('dateDebut', activeModuleIndex!, value)"
          label="Date de début de cycle de formation"
          :hint="HINT_DATE"
          class="col-12 col-md-12 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          :required="metaModuleEnCours?.dateDebut?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.dateDebut?.$messageErreurDirty!"
          :readonly
        />
        <WrapperInputDate
          id="field_24"
          :model-value="moduleEnCours?.dateFin"
          @update:model-value="(value: any) => updateModule('dateFin', activeModuleIndex!, value)"
          label="Date prévue de fin des épreuves ou examens"
          :hint="HINT_DATE"
          class="col-12 col-md-12 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          :required="metaModuleEnCours?.dateFin?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.dateFin?.$messageErreurDirty!"
          :readonly
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { computed, inject, watch } from 'vue'
  import { storeToRefs } from 'pinia'
  import type { ModuleDTO } from '@/features/api/extranet/dto/Demande/PROA'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import { useDemandePROAStore } from '@/features/interface/demande/proa/useDemandePROAStore'
  import { FormContainer, HINT_DATE, PLACEHOLDER_DATE } from '@/features/interface/demande/shared'
  import { PROA_MODULES_ACTIONS } from '../../useModuleActions'

  const store = useDemandePROAStore()
  const { setupArrayUpdaterWithKey } = store
  const { activeModuleIndex, moduleEnCours, metaModuleEnCours } = inject(PROA_MODULES_ACTIONS)!
  const { readonly, lov, model } = storeToRefs(store)

  const updateModule = setupArrayUpdaterWithKey<ModuleDTO>('formation.modules')

  const dureeFoadDisabled = computed(
    () => model.value?.formation?.modules?.[activeModuleIndex.value!]?.modalitePedagogique !== 'Mixte',
  )

  watch(
    () => model.value?.formation?.modules?.[activeModuleIndex.value!]?.modalitePedagogique,
    () => {
      if (model.value?.formation?.modules?.[activeModuleIndex.value!]?.modalitePedagogique === 'Mixte') return

      updateModule('dureeFoad', activeModuleIndex.value!, null)
    },
  )
</script>
